import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import _ from 'lodash';
import moment from 'moment';
import { Subject } from 'rxjs';
import { map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { MfToastService } from './../../../../_shared/services/mfToast.service';
import { TermsService } from './../_services/terms.service';

@Component({
    selector: 'app-covid',
    templateUrl: './covid.component.html',
    styleUrls: ['./covid.component.scss'],
})
export class CovidComponent implements OnInit {
    constructor(
        private route: ActivatedRoute,
        private termsRest: TermsService,
        private toast: MfToastService,
    ) {}
    public guid: string;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public surveysData: any;
    public confirmedByPacient = false;
    private onDestroy$ = new Subject<void>();

    ngOnInit() {
        // //GET guid from routes
        this.route.queryParams
            .pipe(
                takeUntil(this.onDestroy$),
                map(params => params.guid),
                tap(params => {
                    this.guid = params;
                }),
                switchMap(params => {
                    if (!_.isNil(params)) {
                        return this.termsRest.getCovidDataFromGuid(params).pipe(
                            map(data => {
                                _.get(data, 'covidQuestionnaires.covidQuestionnaires', []).map(questionare => {
                                    questionare.callDate = moment(questionare.callDate);
                                    return questionare;
                                });
                                return data;
                            }),
                        );
                    }
                }),
            )
            .subscribe(
                surveysData => {
                    this.confirmedByPacient = _.get(surveysData, 'patientConfirmed', false);
                    this.surveysData = _.get(surveysData, 'covidQuestionnaires.covidQuestionnaires');
                },
                () => {
                    this.toast.error('Napaka pri pridobivanju podatkov.');
                },
            );
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
    ngOnDestroy(): void {
        this.onDestroy$.next();
    }
    public confirmResults() {
        //customer confirms surveys
        this.termsRest
            .confirmCovidSurveysByCustomer(this.guid)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(
                // TODO Ignored with eslint-interactive on 2023-11-10
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                res => {
                    this.confirmedByPacient = true;
                    this.toast.success('Uspešno potrjeno.');
                },
                () => {
                    this.toast.error('Napaka pri potrjevanju');
                },
            );
    }
    get isNew(): boolean {
        const pristineForms = !this.surveysData?.some(survey => survey?.signedBy);
        const newFormSaved: boolean = this.surveysData?.some(survey => survey?.form?.pctDate);
        return pristineForms || newFormSaved;
    }
}
